module.exports = __webpack_public_path__ + "static/media/map-pin-1.75cb2702.svg";